import { Box, Button, Group, IconButton, Input, Text, VStack, HStack, Flex, Grid } from '@chakra-ui/react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
// Local Deps
import { fetchConfigs } from '../../../../actions/actions_config';
import Constants from '../../../../Constants';
import QuantityFields from '../../../../containers/orders/QuantityFields';
import { checkQuantityValidity } from '../../../../functions';
import {
  // getInternalPoLabel,
  isManualPriceStrategyByConfigsAndEndUser,
  isPoHedgingEnabled,
  isQuantityReceivedEditable,
} from '../../../../utils';
import SelectField from '../../../basic/SelectField';
import ProductionDetails from '../ProductionDetails/ProductionDetails';
import { convertCartonsToUnitOfMeasure, lookupUomName } from './helpers';
// import { fetchFormFields } from '../../../../actions/actions_form_fields';
import './InternationalOrderLine.scss';
import { ReactComponent as TrashOutlineIconSVG } from '../../../../assets/trash-outline-icon.svg';
import CustomFormControl from '../../../core/CustomFormControl';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { convertToSnakeCase } from '../../../../helpers';
import { getTenantFromDomain } from '../../../../helpers/tenant';
import POFormFieldLabel from '../edit-form/POFormFieldLabel';
import DateTimeWithTrappedFocus from '../../../core/DateTimeWithTrappedFocus';
import { fetchSpecifications } from '../../../../actions/actions_specifications';
import PriceAdjustment from '../PriceAdjustment/PriceAdjustment';
import CL from '../CL';
import Temperatures from '../Temperature';
import { Tag } from '@/components/ui/tag';
import { Switch } from '@/components/ui/switch';
import {
  PopoverBody,
  PopoverContent,
  PopoverRoot,
  PopoverCloseTrigger,
  PopoverTrigger,
  PopoverArrow,
  PopoverFooter,
} from '@/components/ui/popover';
import { MdAdd } from 'react-icons/md';
import FastInput from '../../../basic/FastInput';

class InternationalOrderLine extends PureComponent {
  static propTypes = {
    buyCurrency: PropTypes.string,
    buyUnitOfMeasureId: PropTypes.number,
    destinationCountry: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    formType: PropTypes.string,
    form: PropTypes.shape({
      endUserId: PropTypes.number,
      status: PropTypes.string,
      buyUnitOfMeasureId: PropTypes.number,
      productType: PropTypes.string,
    }),
    ingredientsOptions: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        delisted: PropTypes.bool,
        label: PropTypes.string.isRequired,
        cl: PropTypes.string,
      })
    ),
    isChilled: PropTypes.bool.isRequired,
    isInEditMode: PropTypes.bool.isRequired,
    hasExpectedProductionDate: PropTypes.bool.isRequired,
    lineIndices: PropTypes.arrayOf(PropTypes.number).isRequired,
    line: PropTypes.shape({
      buyQuantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      buyPricePerUnit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      expectedProductionDate: PropTypes.string,
      idx: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      inputProductUid: PropTypes.string,
      specifications: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
        })
      ),
      sellQuantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      sellPricePerUnit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      cosPricePerUnit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      productionDetails: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          value: PropTypes.string,
        })
      ),
      packageType: PropTypes.string,
      packageCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      packerPlantId: PropTypes.string,
      packerIngredientDescription: PropTypes.string,
      recvQuantity: PropTypes.number,
      hedgeItems: PropTypes.arrayOf(
        PropTypes.shape({
          hedge: PropTypes.number,
          hedgeChg: PropTypes.number,
          hedgeInt: PropTypes.number,
          hedgeLf: PropTypes.number,
        })
      ),
      fobPricePerUnit: PropTypes.string,
      projectedMarketPriceAtDelivery: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      projectedSellPriceAtDelivery: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      orderType: PropTypes.string,
      priceType: PropTypes.string,
      orderTypeNotes: PropTypes.string,
      standing: PropTypes.string,
      active: PropTypes.bool,
      formulaName: PropTypes.string,
      formulaMarket: PropTypes.string,
      formulaDay: PropTypes.string,
      formulaDaysAveraged: PropTypes.string,
      formulaBasis: PropTypes.string,
      contractStartDate: PropTypes.string,
      contractEndDate: PropTypes.string,
      pricePerUnit: PropTypes.string,
      groupHousedPremiumRate: PropTypes.number,
      inputProduct: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
        cl: PropTypes.string,
      }),
      temperatures: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          temperature: PropTypes.string,
        })
      ),
      clResults: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          clvalue: PropTypes.string,
        })
      ),
      opTempType: PropTypes.string,
      opClType: PropTypes.string,
      opAverageThirdPartyClResult: PropTypes.string,
      opTestresult: PropTypes.string,
    }).isRequired,
    lines: PropTypes.instanceOf(Object).isRequired,
    loadSizes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
      })
    ).isRequired,
    onAddLine: PropTypes.func.isRequired,
    onPPUChangeValue: PropTypes.func.isRequired,
    onPPURoundingDecimal: PropTypes.func.isRequired,
    onRemoveLine: PropTypes.func.isRequired,
    onUpdateLine: PropTypes.func.isRequired,
    originCountry: PropTypes.string.isRequired,
    packerPlantId: PropTypes.string.isRequired,
    purchaseOrderId: PropTypes.number,
    purchasingOffice: PropTypes.string,
    purchaseOrderIndex: PropTypes.number.isRequired,
    requiredFields: PropTypes.instanceOf(Object).isRequired,
    requiredFieldsLabels: PropTypes.instanceOf(Object).isRequired,
    sellCurrency: PropTypes.string,
    sellUnitOfMeasureId: PropTypes.number,
    setErrorState: PropTypes.func.isRequired,
    shipmentDateEnd: PropTypes.string,
    submitProductionDetails: PropTypes.func,
    submitPriceAdjustments: PropTypes.func,
    user: PropTypes.instanceOf(Object),
    submitCLResults: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    submitTemperatures: PropTypes.func,
    unitsOfMeasure: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
      })
    ).isRequired,
    configs: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.object]),
      })
    ),
    endUsers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
      })
    ),
    productSpecifications: PropTypes.arrayOf(
      PropTypes.shape({
        uid: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      })
    ),
    packageWeights: PropTypes.arrayOf(
      PropTypes.shape({
        weight: PropTypes.number.isRequired,
        unit: PropTypes.string.isRequired,
      })
    ),
    isUSADomestic: PropTypes.bool,
    isChicagoForm: PropTypes.bool,
    priceTypes: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      })
    ),
    isLocked: PropTypes.bool,
  };

  static defaultProps = {
    ingredientsOptions: [],
  };

  state = {
    activeIndex: false,
    isCartonWeightRequired: true,
    expandHedgeItems: false,
  };

  componentDidMount() {
    const {
      isChilled,
      line,
      ingredientsOptions,
      packerPlantId,
      unitsOfMeasure,
      buyUnitOfMeasureId,
      purchasingOffice,
      productSpecifications,
      packageWeights,
      dispatch,
      configs,
      user,
    } = this.props;

    // Update buy quantity for frozen products when has default carton count
    if (configs.length === 0) {
      dispatch(fetchConfigs(user.token));
    }

    if (
      !ingredientsOptions.find(igdt => igdt.value === line.inputProductUid) &&
      line.inputProductUid &&
      line.inputProduct
    ) {
      ingredientsOptions.push({
        value: line.inputProductUid,
        delisted: true,
        label: line.inputProduct?.name || 'Unknown Product',
        cl: line.inputProduct?.cl || '',
      });
    }
    // default quantity for AACPW is 1 carton, 25kgs, 55lbs
    if (packerPlantId && packerPlantId === 'AACPW') {
      if (!line.packageCount) {
        line.packageCount = 1;
      }
      if (line.packageCount && !isChilled) {
        const ingredient = ingredientsOptions.find(igdt => igdt.value === line.inputProductUid);
        const unitOfMeasure = lookupUomName(unitsOfMeasure, buyUnitOfMeasureId);
        const buyQuantity = convertCartonsToUnitOfMeasure(
          line.packageCount,
          unitOfMeasure,
          // Create a shell of an input product from the ingredient options
          // This is enough to fool converCartonsToUnitOfMeasure
          { uid: ingredient?.value },
          packerPlantId,
          purchasingOffice,
          packageWeights
        );
        this.handleUpdateLine('buyQuantity', line.idx, buyQuantity);
      }
    }
    if (!line.buyPricePerUnit) {
      this.handleOnBlur('buyPricePerUnit', line.idx, 0);
    }
    if (!line.sellPricePerUnit) {
      this.handleOnBlur('sellPricePerUnit', line.idx, 0);
    }
    if (productSpecifications.length === 0) {
      dispatch(fetchSpecifications(user.token));
    }
  }

  componentDidUpdate(prevProps) {
    // Frozen UI toggle is interacted
    const { isChilled, line } = this.props;
    if (prevProps.line.packageCount !== line.packageCount) {
      this.calculateBuyAndSellQuantity();
    }
    if (prevProps.isChilled !== isChilled) {
      this.resetPackageTypeOn(isChilled, line);
      this.resetPackageCountOn(isChilled, line);
      if (isChilled) {
        this.setState({ isCartonWeightRequired: true });
      }
    }
  }

  calculateBuyAndSellQuantity = () => {
    const {
      line,
      ingredientsOptions,
      packerPlantId,
      unitsOfMeasure,
      buyUnitOfMeasureId,
      purchasingOffice,
      packageWeights,
    } = this.props;
    if (
      !ingredientsOptions.find(igdt => igdt.value === line.inputProductUid) &&
      line.inputProductUid &&
      line.inputProduct
    ) {
      ingredientsOptions.push({
        value: line.inputProductUid,
        delisted: true,
        label: line.inputProduct?.name || 'Unknown Product',
        cl: line.inputProduct?.cl || '',
      });
    }
    const ingredient = ingredientsOptions.find(igdt => igdt.value === line.inputProductUid);
    const unitOfMeasure = lookupUomName(unitsOfMeasure, buyUnitOfMeasureId);
    if (line.packageCount !== 0) {
      const buyQuantity = convertCartonsToUnitOfMeasure(
        line.packageCount,
        unitOfMeasure,
        // Create a shell of an input product from th ingredient options
        // This is enough to fool converCartonsToUnitOfMeasure
        { uid: ingredient?.value },
        packerPlantId,
        purchasingOffice,
        packageWeights
      );
      // Only update if the value has actually changed to prevent infinite loops
      if (line.buyQuantity !== buyQuantity) {
        this.handleUpdateLine('buyQuantity', line.idx, buyQuantity);
      }
    }
  };

  resetPackageTypeOn = (isChilled, line) => {
    const { idx } = line;
    const packageType = !isChilled ? Constants.PACKAGE_TYPE.CARTON : Constants.PACKAGE_TYPE.BIN;

    this.handleUpdateLine('packageType', idx, packageType);
  };

  // TODO - temporary solution to ensure that packageCount for cartons are not saved to the db
  // if the order is a fresh load
  resetPackageCountOn = (isChilled, line) => {
    const { idx } = line;

    if (isChilled) {
      this.handleUpdateLine('packageCount', idx, 0);
    }
  };

  onSelectActiveLine = () => {
    const { activeIndex } = this.state;
    this.setState({ activeIndex: !activeIndex });
  };

  handleAddLine = () => {
    this.props.onAddLine();
  };

  handlePackageCount = (packageCountKey, lineIndex, value) => {
    this.handleUpdateLine(packageCountKey, lineIndex, value);
  };

  handleUpdateLine = (fieldName, lineIndex, option) => {
    const {
      buyUnitOfMeasureId,
      setErrorState,
      lines,
      originCountry,
      destinationCountry,
      loadSizes,
      onUpdateLine,
      shipmentDateEnd,
    } = this.props;
    const value = get(option, 'value', option);
    if (fieldName === 'buyQuantity') {
      const buyQuantityError = checkQuantityValidity({
        fieldName,
        originCountry,
        destinationCountry,
        lines,
        loadSizes,
        buyUnitOfMeasureId,
        lineBuyQuantity: value,
        lineIndex,
      });
      // TODO change it to accept string, not boolean for consistency
      if (buyQuantityError) {
        return setErrorState('buyQuantity', true);
      }
      setErrorState('buyQuantity', false);
    }

    if (fieldName === 'expectedProductionDate' && shipmentDateEnd) {
      if (option > shipmentDateEnd) {
        return setErrorState('dateError', 'Expected production date cannot be after Shipment End date.');
      }
      setErrorState('dateError', null);
    }
    if (fieldName === 'inputProductUid') {
      this.props.line.packageCount = 0;
      this.props.line.buyQuantity = 0;
    }

    if (fieldName === 'specifications') {
      return onUpdateLine(
        lineIndex,
        fieldName,
        value?.map(el => {
          return el.value;
        })
      );
    }

    return onUpdateLine(lineIndex, fieldName, value);
  };

  handleRemoveLine = () => {
    const { line, onRemoveLine } = this.props;
    onRemoveLine(line.idx, line);
  };

  handleProductionDetailsChange = (
    lineIdx,
    lineId,
    productionDetails,
    toDeleteProductionDetailsIds,
    productionDetailsKey = 'productionDetails'
  ) => {
    const { submitProductionDetails } = this.props;
    submitProductionDetails(lineIdx, lineId, productionDetails, toDeleteProductionDetailsIds, productionDetailsKey);
  };

  handlePriceAdjustmentsChange = (lineIdx, lineId, priceAdjustments, toDeletePriceAdjustmentIds) => {
    const { submitPriceAdjustments } = this.props;
    if (submitPriceAdjustments) submitPriceAdjustments(lineIdx, lineId, priceAdjustments, toDeletePriceAdjustmentIds);
  };

  handleToggleCartonWeight = () => {
    const { isCartonWeightRequired } = this.state;
    this.setState({ isCartonWeightRequired: !isCartonWeightRequired });
  };

  handleOnBlur = (name, index, value) => {
    const { onPPURoundingDecimal, onPPUChangeValue, line } = this.props;

    const currentValue = get(line, name);
    if (currentValue === undefined || !currentValue) {
      // eslint-disable-next-line no-param-reassign
      value = 0;
      onPPUChangeValue(name, index, value);
    }
    onPPURoundingDecimal(name, index, value);
  };

  handleCLChange = (lineIdx, fieldName, value) => {
    const { submitCLResults } = this.props;
    submitCLResults(lineIdx, fieldName, value);
    this.handleUpdateLine(fieldName, lineIdx, value);
  };

  handleTemperatureChanges = (lineIdx, fieldName, value) => {
    const { submitTemperatures } = this.props;
    submitTemperatures(lineIdx, fieldName, value);
    this.handleUpdateLine(fieldName, lineIdx, value);
  };

  render() {
    const {
      buyUnitOfMeasureId,
      buyCurrency,
      hasExpectedProductionDate,
      ingredientsOptions,
      isInEditMode,
      formType,
      form,
      line,
      lineIndices,
      onPPURoundingDecimal,
      onPPUChangeValue,
      purchaseOrderId,
      purchaseOrderIndex,
      requiredFields,
      unitsOfMeasure,
      sellCurrency,
      sellUnitOfMeasureId,
      isChilled,
      packerPlantId,
      purchasingOffice,
      configs,
      packageWeights,
      productSpecifications,
      requiredFieldsLabels,
      isUSADomestic,
      isChicagoForm,
      priceTypes,
      endUsers,
      isLocked,
      filteredPriceAgreementOptions,
    } = this.props;

    if (
      !ingredientsOptions.find(igdt => igdt.value === line.inputProductUid) &&
      line.inputProductUid &&
      line.inputProduct
    ) {
      ingredientsOptions.push({
        value: line.inputProductUid,
        delisted: true,
        label: line.inputProduct?.name || 'Unknown Product',
        cl: line.inputProduct?.cl || '',
      });
    }
    const { buyQuantity, sellQuantity, buyPricePerUnit, sellPricePerUnit, cosPricePerUnit, recvQuantity } = line;
    const isCFC = getTenantFromDomain().includes('cfc');
    const index = line.idx;
    const isLast = index === lineIndices[lineIndices.length - 1];
    const hidePopconfirm = lineIndices.length === 1;
    const isFrozenProduct = !isChilled;

    const ingredient = ingredientsOptions.find(igdt => igdt.value === line.inputProductUid);

    let requiredFieldErrors = [];
    let requiredFieldNames = [];
    // TODO make one format for capturing errors
    // check for the errors from multiple po creation
    if (purchaseOrderIndex) {
      requiredFieldErrors = get(requiredFields, `pos.${purchaseOrderIndex}.lines.${index}`, []);
      requiredFieldNames = get(requiredFieldsLabels, `pos.${purchaseOrderIndex}.lines.${index}`, []);
    }
    // if not check for errors in edit form
    if (!requiredFieldErrors.length) {
      requiredFieldErrors = get(requiredFields, `lines[${line.id}]`, []);
    }
    if (!requiredFieldNames.length) requiredFieldNames = get(requiredFieldsLabels, `lines[${line.id}]`, []);

    const isRecvQuantityEditable = isQuantityReceivedEditable(configs);
    const isManualPriceStrategyValue = isManualPriceStrategyByConfigsAndEndUser(configs, endUsers, form.endUserId);
    const poHedgingEnabled = isPoHedgingEnabled(configs);

    const specificationOptions = productSpecifications.map(el => {
      return { value: convertToSnakeCase(el.uid), label: el.name };
    });

    // const internalPoLabel = getInternalPoLabel(configs);
    const specificationValues = specificationOptions?.filter(el => line.specifications.includes(el.value));

    const priceTypeOptions = [];
    const { isCartonWeightRequired, expandHedgeItems } = this.state;

    priceTypes.forEach(element => {
      const capitalized = element.value.charAt(0).toUpperCase() + element.value.slice(1);
      priceTypeOptions.push({ value: element.value, label: capitalized });
    });

    return (
      <VStack align="stretch" gap="30px" backgroundColor="inherit">
        <HStack width="100%" backgroundColor="inherit">
          <Text
            as="p"
            fontSize="15px"
            font-size="15px"
            textTransform="uppercase"
            borderBottomWidth="1px"
            width="100%"
            textAlign="center"
            lineHeight="0.1em"
            // marginTop="-27px"
            backgroundColor="inherit"
          >
            <Box as="span" backgroundColor="inherit" padding="0 15px">
              Purchase Order Line #{index}
            </Box>
          </Text>
          {isInEditMode && (
            <>
              {/* <!-- CANCEL LINE BUTTON --> */}
              {!hidePopconfirm && (
                <PopoverRoot>
                  <PopoverTrigger>
                    <IconButton disabled={!isInEditMode} hidden={!isInEditMode}>
                      <TrashOutlineIconSVG />
                    </IconButton>
                  </PopoverTrigger>
                  <PopoverContent>
                    <PopoverArrow />
                    <PopoverCloseTrigger />
                    <PopoverBody p={6}>Are you sure you want to delete this line?</PopoverBody>
                    <PopoverFooter>
                      <Group gap={2}>
                        <Button bg="primary.900" color="white" onClick={this.handleRemoveLine}>
                          Yes
                        </Button>
                      </Group>
                    </PopoverFooter>
                  </PopoverContent>
                </PopoverRoot>
              )}
              {isLast && (
                <IconButton
                  onClick={this.handleAddLine}
                  disabled={!isInEditMode}
                  hidden={!isInEditMode}
                  colorScheme="actionSecondary"
                  height="35px"
                  width="35px"
                  borderRadius="18px"
                >
                  <MdAdd className="international-order-line__icon--orange" />
                </IconButton>
              )}
            </>
          )}
        </HStack>
        {!line.active && (
          <Flex justifyContent="flex-end">
            <Tag variant="solid" borderRadius="2px" backgroundColor="#e53e3e">
              Canceled
            </Tag>
          </Flex>
        )}
        <Grid templateColumns="repeat(4, 1fr)" gap="18px" paddingX="10px" width="100%">
          {/* <!-- INGREDIENT SELECT --> */}
          <Box width="100%">
            <POFormFieldLabel
              label="Product"
              htmlFor="select-input-product"
              fieldName="inputProductUid"
              className="international-order-line__label"
              isRequired={requiredFieldNames.includes('inputProductUid')}
              tooltip="Select the specific product from the dropdown list."
            />
            <SelectField
              disabled={!isInEditMode}
              name="select-input-product"
              defaultValue={line.inputProductUid}
              options={ingredientsOptions?.sort((a, b) => (a.label > b.label ? 1 : -1))}
              className={requiredFieldErrors.includes('inputProductUid') ? 'error' : ''}
              onChange={e => {
                this.handleUpdateLine('inputProductUid', index, e);
              }}
              controlStyles={{ height: '38px' }}
            />
          </Box>
          {/* INGREDIENT DESCRIPTION */}
          {purchaseOrderId && (
            <CustomFormControl width="100%" gap={0}>
              <POFormFieldLabel
                label="Description"
                htmlFor="select-input-ingredient-description"
                className="international-order-line__input-product-desc"
                tooltip="Enter a detailed description of the product."
              />
              <FastInput
                height="40px"
                disabled={!isInEditMode}
                name="select-ingredient-description"
                value={line.packerIngredientDescription || get(line, 'input_product.description') || ''}
                onChange={value => {
                  this.handleUpdateLine('packerIngredientDescription', index, value);
                }}
              />
            </CustomFormControl>
          )}
          <Box width="100%">
            {/* <!-- CHECKBOX GROUP --> */}
            <POFormFieldLabel
              label="Specifications"
              htmlFor="select-specifications"
              className="international-order-line__specifications"
              tooltip="Provide the product specifications."
            />
            <SelectField
              className="international-order-line__select"
              isClearable
              disabled={!isInEditMode}
              isSearchable
              closeMenuOnSelect={false}
              removeSelected
              isMulti
              name="select-specifications"
              defaultValue={specificationValues}
              onChange={e => this.handleUpdateLine('specifications', index, e)}
              options={specificationOptions}
            />
          </Box>
          {((isUSADomestic && !isFrozenProduct) || form.status === Constants.ORDER_STATUSES.DRAFT) && (
            <>
              <Box>
                <POFormFieldLabel
                  label="Order Type"
                  tooltip="Specifies the nature of the order (Spot, Contract, Formula, Other, NOF)."
                  htmlFor="orderType"
                  fieldName="orderType"
                  className="international-order-line__label"
                />
                <SelectField
                  className="international-order-line__select"
                  disabled={!isInEditMode}
                  closeMenuOnSelect={false}
                  isMulti={false}
                  name="select-orderType"
                  defaultValue={line.priceType}
                  value={priceTypeOptions.find(option => option.value === line.priceType) || null}
                  onChange={e => this.handleUpdateLine('priceType', index, e.value)}
                  options={priceTypeOptions}
                />
              </Box>

              {form.status !== Constants.ORDER_STATUSES.CANCELLED &&
                form.status !== Constants.ORDER_STATUSES.ORDERED &&
                form.status !== Constants.ORDER_STATUSES.PENDING &&
                form.status !== Constants.ORDER_STATUSES.ON_HOLD &&
                line.priceType === 'formula' && (
                  <>
                    <Box>
                      <POFormFieldLabel
                        label="Formula Name"
                        htmlFor="formulaName"
                        fieldName="formulaName"
                        className="international-order-line__label"
                      />
                      <SelectField
                        {...{
                          className: 'international-order-line__select',
                          disabled: !isInEditMode,
                          isSearchable: true,
                          closeMenuOnSelect: false,
                          isMulti: false,
                          name: 'select-formulaName',
                          defaultValue: line.formulaName,
                          onChange: e => this.handleUpdateLine('formulaName', index, e.value),
                          options: [
                            {
                              value: 'USDA National Weds 7d|usda,3,7',
                              label: 'USDA National Weds 7d',
                            },
                            {
                              value: 'USDA National Fri 7d|usda,5,7',
                              label: 'USDA National Fri 7d',
                            },
                            {
                              value: 'USDA National Weds 5d|usda,3,5',
                              label: 'USDA National Weds 5d',
                            },
                            {
                              value: 'USDA National Fri 5d|usda,5,5',
                              label: 'USDA National Fri 5d',
                            },
                          ],
                        }}
                      />
                    </Box>

                    <Box>
                      <POFormFieldLabel
                        label="Market"
                        htmlFor="formulaMarket"
                        fieldName="formulaMarket"
                        className="international-order-line__label"
                      />
                      <SelectField
                        className="international-order-line__select"
                        disabled={!isInEditMode}
                        isSearchable
                        closeMenuOnSelect={false}
                        isMulti={false}
                        name="select-formulaMarket"
                        defaultValue={line.formulaMarket}
                        onChange={e => this.handleUpdateLine('formulaMarket', index, e.value)}
                        options={[
                          {
                            value: 'USDA National',
                            label: 'USDA National',
                          },
                        ]}
                      />
                    </Box>

                    <Box>
                      <POFormFieldLabel
                        label="Day"
                        htmlFor="formulaDay"
                        fieldName="formulaDay"
                        className="international-order-line__label"
                      />
                      <SelectField
                        className="international-order-line__select"
                        disabled={!isInEditMode}
                        isSearchable
                        closeMenuOnSelect={false}
                        isMulti={false}
                        name="select-formulaDay"
                        defaultValue={line.formulaDay}
                        onChange={e => this.handleUpdateLine('formulaDay', index, e.value)}
                        options={[
                          {
                            value: '',
                            label: '(none)',
                          },
                          {
                            value: '1',
                            label: 'Mon',
                          },
                          {
                            value: '2',
                            label: 'Tue',
                          },
                          {
                            value: '3',
                            label: 'Wed',
                          },
                          {
                            value: '4',
                            label: 'Thu',
                          },
                          {
                            value: '5',
                            label: 'Fri',
                          },
                          {
                            value: '6',
                            label: 'Sat',
                          },
                          {
                            value: '0',
                            label: 'Sun',
                          },
                        ]}
                      />
                    </Box>

                    <CustomFormControl>
                      <POFormFieldLabel
                        label="Avg. Days"
                        htmlFor="formulaDaysAveraged"
                        fieldName="formulaDaysAveraged"
                        className="international-order-line__label"
                      />
                      <Input
                        className="form-control"
                        value={line.formulaDaysAveraged || ''}
                        disabled={!isInEditMode}
                        placeholder="Add notes"
                        type="number"
                        step=".01"
                        max="0"
                        onChange={e => this.handleUpdateLine('formulaDaysAveraged', index, e.target.value)}
                        backgroundColor={!isInEditMode ? 'inherit' : 'white'}
                      />
                    </CustomFormControl>

                    <CustomFormControl>
                      <POFormFieldLabel
                        label="Basis"
                        htmlFor="formulaBasis"
                        fieldName="formulaBasis"
                        className="international-order-line__label"
                      />
                      <Input
                        className="form-control"
                        value={line.formulaBasis || ''}
                        disabled={!isInEditMode}
                        placeholder="Add notes"
                        type="number"
                        step=".01"
                        max="0"
                        onChange={e => this.handleUpdateLine('formulaBasis', index, e.target.value)}
                        backgroundColor={!isInEditMode ? 'inherit' : 'white'}
                      />
                    </CustomFormControl>
                  </>
                )}

              {form.status !== Constants.ORDER_STATUSES.CANCELLED &&
                form.status !== Constants.ORDER_STATUSES.ORDERED &&
                form.status !== Constants.ORDER_STATUSES.PENDING &&
                form.status !== Constants.ORDER_STATUSES.ON_HOLD &&
                line.priceType === 'contract' && (
                  <>
                    <CustomFormControl>
                      <POFormFieldLabel
                        label="Contract Start Date"
                        htmlFor="contract_start_date"
                        className="international-order-line__label"
                        fieldName="contractStartDate"
                      />
                      <DateTimeWithTrappedFocus
                        id="contract_start_date"
                        name="contract_start_date"
                        inputProps={{
                          className: 'form-control m-input',
                          disabled: !isInEditMode,
                        }}
                        closeOnSelect
                        value={line.contractStartDate}
                        onChange={e =>
                          this.handleUpdateLine(
                            'contractStartDate',
                            index,
                            e?._isAMomentObject ? e?.format('YYYY-MM-DD') : e // eslint-disable-line no-underscore-dangle
                          )
                        }
                        className={requiredFieldErrors.includes('contractStartDate') ? 'error' : ''}
                        timeFormat={false}
                        dateFormat="YYYY-MM-DD"
                      />
                    </CustomFormControl>

                    <CustomFormControl>
                      <POFormFieldLabel
                        label="Contract End Date"
                        htmlFor="contract_end_date"
                        className="international-order-line__label"
                        fieldName="contractEndDate"
                      />
                      <DateTimeWithTrappedFocus
                        id="contract_end_date"
                        name="contract_end_date"
                        inputProps={{
                          className: 'form-control m-input',
                          disabled: !isInEditMode,
                        }}
                        closeOnSelect
                        value={line.contractEndDate}
                        onChange={e =>
                          this.handleUpdateLine(
                            'contractEndDate',
                            index,
                            e?._isAMomentObject ? e?.format('YYYY-MM-DD') : e // eslint-disable-line no-underscore-dangle
                          )
                        }
                        className={requiredFieldErrors.includes('contractEndDate') ? 'error' : ''}
                        timeFormat={false}
                        dateFormat="YYYY-MM-DD"
                      />
                    </CustomFormControl>
                  </>
                )}
              <CustomFormControl width="305px">
                <POFormFieldLabel
                  label="Price Agreement"
                  htmlFor="select-price_agreement"
                  fieldName="priceAgreementId"
                  className="international-order-line__label"
                  tooltip="Select the specific price agreement from the dropdown list."
                />
                <SelectField
                  disabled={!isInEditMode}
                  name="select-price_agreement"
                  defaultValue={line.priceAgreementId}
                  options={filteredPriceAgreementOptions?.sort((a, b) => (a.label > b.label ? 1 : -1))}
                  // className={requiredFieldErrors.includes('inputProductUid') ? 'error' : ''}
                  onChange={e => {
                    this.handleUpdateLine('priceAgreementId', index, e);
                  }}
                  controlStyles={{ height: '38px' }}
                />
              </CustomFormControl>
              <CustomFormControl width="100%">
                <POFormFieldLabel
                  label="Order Type Notes"
                  htmlFor="orderTypeNotes"
                  fieldName="orderTypeNotes"
                  className="international-order-line__label"
                />
                <Input
                  className="form-control"
                  value={line.orderTypeNotes || ''}
                  disabled={!isInEditMode}
                  placeholder="Add notes"
                  onChange={e => this.handleUpdateLine('orderTypeNotes', index, e.target.value)}
                  backgroundColor={!isInEditMode ? 'inherit' : 'white'}
                />
              </CustomFormControl>

              <Box>
                <POFormFieldLabel
                  label="Standing"
                  htmlFor="standing"
                  fieldName="standing"
                  className="international-order-line__label"
                />
                <SelectField
                  className="international-order-line__select"
                  disabled={!isInEditMode}
                  isSearchable
                  closeMenuOnSelect={false}
                  isMulti={false}
                  name="select-standing"
                  defaultValue={line.standing}
                  onChange={e => this.handleUpdateLine('standing', index, e.value)}
                  options={[
                    {
                      value: 'yes',
                      label: 'Yes',
                    },
                    {
                      value: 'no',
                      label: 'No',
                    },
                  ]}
                />
              </Box>
            </>
          )}

          {!isChilled && (
            <CustomFormControl width="120px">
              <POFormFieldLabel
                label="Carton Weight"
                htmlFor="isCartonWeightRequired"
                className="date-section__label"
                tooltip="Indicate whether the carton weight is applicable (Yes or No)."
              />
              <Switch
                id="isCartonWeightRequired"
                onChange={this.handleToggleCartonWeight}
                defaultChecked={this.state.isCartonWeightRequired} // Access from state
                colorScheme="actionPrimary"
                size="lg"
                marginY="5px"
                disabled={!isInEditMode}
              />
            </CustomFormControl>
          )}
        </Grid>
        <Flex gap="56px" paddingX="10px" width="100%">
          {/* <!--- PACKAGE COUNT ----> */}
          {isCartonWeightRequired && !isChilled && (
            <CustomFormControl width="166px">
              <POFormFieldLabel
                label="Cartons Number"
                htmlFor="packageCount"
                className="international-order-line__specifications"
                fieldName="cartonsNumber"
                isRequired={isCartonWeightRequired}
                tooltip="Specify the number of cartons in the order."
              />
              <FastInput
                name="packageCount"
                type="number"
                value={line.packageCount || ''}
                disabled={!isInEditMode}
                onChange={value => this.handleUpdateLine('packageCount', index, value)}
                className={
                  requiredFieldErrors.includes('buyQuantity') || requiredFieldErrors.includes('sellQuantity')
                    ? 'error'
                    : ''
                }
                onWheel={e => e.target.blur()}
                height="40px"
                autoComplete="off"
                inputMode="decimal"
              />
              <input type="hidden" name="packageType" value={line.packageType || ''} />
            </CustomFormControl>
          )}
          {/* <!-- QUANTITY FIELDS --> */}
          <QuantityFields
            {...{
              buyQuantity,
              buyUnitOfMeasureId,
              errors: requiredFieldErrors.length ? requiredFieldErrors : null,
              requiredFieldNames,
              index,
              isInEditMode,
              onLineValueChange: this.handleUpdateLine,
              sellQuantity,
              sellUnitOfMeasureId,
              unitsOfMeasure,
              isFrozenProduct,
              ingredient,
              packerUid: packerPlantId,
              purchasingOffice,
              recvQuantity,
              isRecvQuantityEditable,
              packageWeights,
              purchaseOrderId,
              isCartonWeightRequired,
              configs, 
              isUSADomestic, 
              isChilled, 
              line
            }}
          />
        </Flex>
        <Flex gap="19px" paddingX="10px" width="100%" alignItems="flex-end">
          <HStack gap="15px" alignItems="flex-end">
            {isUSADomestic && !isFrozenProduct && (
              <CustomFormControl width="165px">
                <POFormFieldLabel
                  label="FOB Price"
                  htmlFor="fobPricePerUnit"
                  fieldName="fobPricePerUnit"
                  className="international-order-line__label"
                  tooltip="Captures the Free on Board (FOB) price at the point of shipment."
                />
                <HStack gap="7px">
                  <FastInput
                    id="pricePerUnit"
                    name="pricePerUnit"
                    pattern={Constants.PRICE_NUMBER_FIELD_PATTERN}
                    disabled={!buyCurrency || !isInEditMode}
                    borderColor={requiredFieldErrors.includes('pricePerUnit') ? 'red' : 'inherit'}
                    type="number"
                    value={line.pricePerUnit}
                    onFocus={event => event.target.select()}
                    step="0.0001"
                    onChange={value => onPPUChangeValue('pricePerUnit', index, value)}
                    onBlur={e => this.handleOnBlur('pricePerUnit', index, e.target.value)}
                    width="125px"
                    height="40px"
                    onWheel={e => e.target.blur()}
                  />
                  <label htmlFor="fobPrice">{buyCurrency}</label>
                </HStack>
              </CustomFormControl>
            )}
            {/* <!-- EDIT PO -> GROUP HOUSED PREMIUM ONLY FOR PRODUCT TYPE PORK  --> */}
            {form.productType === Constants.PRODUCT_TYPE_LIST.PORK && isUSADomestic && (
              <CustomFormControl width="200px">
                <POFormFieldLabel
                  label="Group Housed Premium"
                  htmlFor="groupHousedPremium"
                  fieldName="groupHousedPremium"
                  className="international-order-line__label"
                  tooltip="Indicates the Cost of Group Housed Premium for Group Housed product"
                />

                <HStack gap="7px">
                  <Input
                    id="groupHousedPremiumRate"
                    name="groupHousedPremiumRate"
                    pattern={Constants.PRICE_NUMBER_FIELD_PATTERN}
                    disabled={!isInEditMode}
                    // borderColor={requiredFieldErrors.includes('pricePerUnit') ? 'red' : 'inherit'}
                    type="number"
                    value={line.groupHousedPremiumRate}
                    onFocus={event => event.target.select()}
                    step="0.0001"
                    onChange={e => onPPUChangeValue('groupHousedPremiumRate', index, e.target.value)}
                    onBlur={e => this.handleOnBlur('groupHousedPremiumRate', index, e.target.value)}
                    width="125px"
                    height="40px"
                    onWheel={e => e.target.blur()}
                  />
                  <label htmlFor="groupHousedPremium">{buyCurrency}</label>
                </HStack>
              </CustomFormControl>
            )}
            {isCFC && (
              <CustomFormControl width="165px">
                <POFormFieldLabel
                  label="Projected Market Price at Delivery"
                  htmlFor="projectedMarketPriceAtDelivery"
                  fieldName="projectedMarketPriceAtDelivery"
                  className="international-order-line__label"
                  tooltip="Expected market price at time of order creation."
                />
                <HStack gap="7px">
                  <FastInput
                    id="projectedMarketPriceAtDelivery"
                    name="projectedMarketPriceAtDelivery"
                    pattern={Constants.PRICE_NUMBER_FIELD_PATTERN}
                    disabled={!isInEditMode}
                    type="number"
                    value={line.projectedMarketPriceAtDelivery ?? ''}
                    onFocus={event => event.target.select()}
                    step="0.0001"
                    min="0"
                    onChange={value => onPPUChangeValue('projectedMarketPriceAtDelivery', index, value)}
                    onKeyDown={e => { if (['e', 'E', '+'].includes(e.key)) e.preventDefault(); }}
                    onBlur={e => {
                      if (e.target.value === '') return;
                      const val = parseFloat(e.target.value);
                      if (!isNaN(val) && val < 0) onPPUChangeValue('projectedMarketPriceAtDelivery', index, 0);
                      else this.handleOnBlur('projectedMarketPriceAtDelivery', index, e.target.value);
                    }}
                    width="125px"
                    height="40px"
                    onWheel={e => e.target.blur()}
                  />
                  <label htmlFor="projectedMarketPriceAtDelivery">{buyCurrency}</label>
                </HStack>
              </CustomFormControl>
            )}
            <CustomFormControl width="165px">
              <POFormFieldLabel
                label="Buy Unit Price"
                htmlFor="buyPricePerUnit"
                fieldName="buyPricePerUnit"
                className="international-order-line__label"
                tooltip="Specifies the price based on the values selected in Currency (Buy)."
              />
              <HStack gap="7px">
                <FastInput
                  id="buyPricePerUnit"
                  name="buyPricePerUnit"
                  pattern={Constants.PRICE_NUMBER_FIELD_PATTERN}
                  disabled={!buyCurrency || !isInEditMode}
                  borderColor={requiredFieldErrors.includes('buyPricePerUnit') ? 'red' : 'inherit'}
                  type="number"
                  value={buyPricePerUnit}
                  onFocus={event => event.target.select()}
                  step="0.0001"
                  onChange={value => onPPUChangeValue('buyPricePerUnit', index, value)}
                  onBlur={e => this.handleOnBlur('buyPricePerUnit', index, e.target.value)}
                  width="125px"
                  height="40px"
                  onWheel={e => e.target.blur()}
                />
                <label htmlFor="buyPricePerUnit">{buyCurrency}</label>
              </HStack>
            </CustomFormControl>
            {/* <!-- COS UNIT PRICE --> */}
            {formType === 'editForm' && !isManualPriceStrategyValue && (
              <CustomFormControl width="165px">
                <POFormFieldLabel
                  label="COS Unit Price"
                  htmlFor="cosPricePerUnit"
                  fieldName="cosPricePerUnit"
                  className="international-order-line__label"
                  tooltip="Specifies the price based on the values selected in Currency (Buy)."
                />
                <HStack gap="7px">
                  <FastInput
                    id="cosPricePerUnit"
                    name="cosPricePerUnit"
                    pattern={Constants.PRICE_NUMBER_FIELD_PATTERN}
                    disabled
                    borderColor={requiredFieldErrors.includes('buyPricePerUnit') ? 'red' : 'inherit'}
                    type="number"
                    onWheel={e => e.target.blur()}
                    value={cosPricePerUnit || ''}
                    step="0.0001"
                    onChange={value => onPPUChangeValue('cosPricePerUnit', index, value)}
                    onBlur={e => onPPURoundingDecimal('cosPricePerUnit', index, e.target.value)}
                    width="125px"
                    height="40px"
                  />
                  <label htmlFor="cosPricePerUnit">{sellCurrency}</label>
                </HStack>
              </CustomFormControl>
            )}
          </HStack>
          {/* <!-- PRICE PER UNIT SELL --> */}
          {(formType === 'editForm' || isManualPriceStrategyValue) && (
            <CustomFormControl width="165px">
              <POFormFieldLabel
                label="Sell Unit Price"
                htmlFor="sellPricePerUnit"
                fieldName="sellPricePerUnit"
                className="international-order-line__label"
                tooltip="Specifies the price based on the values selected in Currency (Sell)."
              />
              <HStack gap="7px">
                <FastInput
                  id="sellPricePerUnit"
                  name="sellPricePerUnit"
                  pattern={Constants.PRICE_NUMBER_FIELD_PATTERN}
                  disabled={!buyCurrency || !isInEditMode || !isManualPriceStrategyValue}
                  borderColor={requiredFieldErrors.includes('sellPricePerUnit') ? 'red' : 'inherit'}
                  type="number"
                  value={sellPricePerUnit}
                  onWheel={e => e.target.blur()}
                  step="0.0001"
                  onChange={value => onPPUChangeValue('sellPricePerUnit', index, value)}
                  onBlur={e => this.handleOnBlur('sellPricePerUnit', index, e.target.value)}
                  width="125px"
                  height="40px"
                />
                <label htmlFor="cosPricePerUnit">{sellCurrency}</label>
              </HStack>
            </CustomFormControl>
          )}
          {isCFC && (formType === 'editForm' || isManualPriceStrategyValue) && (
            <CustomFormControl width="165px">
              <POFormFieldLabel
                label="Projected Sell Price at Delivery"
                htmlFor="projectedSellPriceAtDelivery"
                fieldName="projectedSellPriceAtDelivery"
                className="international-order-line__label"
                tooltip="Expected selling price at time of order creation."
              />
              <HStack gap="7px">
                <FastInput
                  id="projectedSellPriceAtDelivery"
                  name="projectedSellPriceAtDelivery"
                  pattern={Constants.PRICE_NUMBER_FIELD_PATTERN}
                  disabled={!isInEditMode}
                  type="number"
                  value={line.projectedSellPriceAtDelivery ?? ''}
                  onFocus={event => event.target.select()}
                  step="0.0001"
                  min="0"
                  onChange={value => onPPUChangeValue('projectedSellPriceAtDelivery', index, value)}
                  onKeyDown={e => { if (['e', 'E', '+'].includes(e.key)) e.preventDefault(); }}
                  onBlur={e => {
                    if (e.target.value === '') return;
                    const val = parseFloat(e.target.value);
                    if (!isNaN(val) && val < 0) onPPUChangeValue('projectedSellPriceAtDelivery', index, 0);
                    else this.handleOnBlur('projectedSellPriceAtDelivery', index, e.target.value);
                  }}
                  width="125px"
                  height="40px"
                  onWheel={e => e.target.blur()}
                />
                <label htmlFor="projectedSellPriceAtDelivery">{sellCurrency}</label>
              </HStack>
            </CustomFormControl>
          )}
          {hasExpectedProductionDate && (
            <CustomFormControl width="264px">
              <POFormFieldLabel
                label="Expected Production Date"
                htmlFor="fabrication-date"
                className="international-order-line__label"
                fieldName="expectedProductionDate"
                isRequired={requiredFieldNames.includes('expectedProductionDate')}
                tooltip="Indicates the anticipated date when the product will be manufactured."
              />
              <DateTimeWithTrappedFocus
                id="fabrication-date"
                name="fabrication-date"
                inputProps={{
                  className: 'form-control m-input',
                  disabled: !isInEditMode,
                }}
                closeOnSelect
                value={line.expectedProductionDate}
                onChange={e =>
                  this.handleUpdateLine(
                    'expectedProductionDate',
                    index,
                    e?._isAMomentObject ? e?.format('YYYY-MM-DD') : e // eslint-disable-line no-underscore-dangle
                  )
                }
                className={requiredFieldErrors.includes('expectedProductionDate') ? 'error' : ''}
                timeFormat={false}
                dateFormat="YYYY-MM-DD"
              />
            </CustomFormControl>
          )}
          {/* <!-- Multiple Prod dates --> */}
        </Flex>
        {isUSADomestic && !isFrozenProduct && (
          <Box paddingX="10px">
            <PriceAdjustment
              line={line}
              isInEditMode={isInEditMode}
              onChange={this.handlePriceAdjustmentsChange}
              isLocked={isLocked}
            />
          </Box>
        )}
        {purchaseOrderId && (
          <Box paddingX="10px">
            <ProductionDetails
              {...{
                unitsOfMeasure,
                line,
                isInEditMode,
                index,
                onChange: this.handleProductionDetailsChange,
                isFrozenProduct,
                isUSADomestic,
                isChicago: isChicagoForm,
                buyUnitOfMeasureId: form.buyUnitOfMeasureId,
                onUpdateLine: this.handleUpdateLine,
              }}
            />
          </Box>
        )}
        {purchaseOrderId && poHedgingEnabled && (
          <VStack paddingX="10px" align="stretch">
            <HStack justifyContent="space-between" color="accent.one.default" width="150px">
              <Text as="p" fontWeight="medium" color="inherit">
                Hedge Details
              </Text>
              <IconButton
                variant="unstyled"
                minWidth="18px"
                height="fit-content"
                padding="0px"
                fontSize="18px"
                onClick={() => this.setState({ expandHedgeItems: !expandHedgeItems })}
              >
                {expandHedgeItems ? <FaChevronDown /> : <FaChevronRight />}
              </IconButton>
            </HStack>
            {expandHedgeItems && (
              <Flex gap="54px">
                <CustomFormControl width="125px">
                  <POFormFieldLabel
                    label="Hedge"
                    htmlFor="hedge"
                    fieldName="hedge"
                    className="international-order-line__col"
                    isRequired={requiredFieldNames.includes('hedge')}
                  />
                  <FastInput
                    name="hedge"
                    type="number"
                    value={line?.hedgeItems?.hedge || ''}
                    disabled={!isInEditMode}
                    onWheel={e => e.target.blur()}
                    className={requiredFieldErrors.includes('hedge') ? 'form-control error' : 'form-control'}
                    onChange={value => this.handleUpdateLine('hedgeItems.hedge', index, value)}
                    onBlur={e => e.target.value === '' && this.handleUpdateLine('hedgeItems.hedge', index, null)}
                    backgroundColor="white"
                  />
                </CustomFormControl>
                <CustomFormControl width="125px">
                  <POFormFieldLabel
                    label="Hedge CHG"
                    htmlFor="hedgeChg"
                    fieldName="hedgeChg"
                    className="international-order-line__col"
                    isRequired={requiredFieldNames.includes('hedgeChg')}
                  />
                  <FastInput
                    name="hedgeChg"
                    type="number"
                    onWheel={e => e.target.blur()}
                    value={line?.hedgeItems?.hedgeChg || ''}
                    disabled={!isInEditMode}
                    className={requiredFieldErrors.includes('hedgeChg') ? 'form-control error' : 'form-control'}
                    onChange={value => this.handleUpdateLine('hedgeItems.hedgeChg', index, value)}
                    onBlur={e => e.target.value === '' && this.handleUpdateLine('hedgeItems.hedgeChg', index, null)}
                    backgroundColor="white"
                  />
                </CustomFormControl>
                <CustomFormControl width="125px">
                  <POFormFieldLabel
                    label="Hedge INT"
                    htmlFor="hedgeInt"
                    fieldName="hedgeInt"
                    className="international-order-line__col"
                    isRequired={requiredFieldNames.includes('hedgeInt')}
                  />
                  <FastInput
                    name="hedgeInt"
                    type="number"
                    onWheel={e => e.target.blur()}
                    value={line?.hedgeItems?.hedgeInt || ''}
                    disabled={!isInEditMode}
                    className={requiredFieldErrors.includes('hedgeInt') ? 'form-control error' : 'form-control'}
                    onChange={value => this.handleUpdateLine('hedgeItems.hedgeInt', index, value)}
                    onBlur={e => e.target.value === '' && this.handleUpdateLine('hedgeItems.hedgeInt', index, null)}
                    backgroundColor="white"
                  />
                </CustomFormControl>
                <CustomFormControl width="125px">
                  <POFormFieldLabel
                    label="Hedge LF"
                    htmlFor="hedgeLf"
                    fieldName="hedgeLf"
                    className="international-order-line__col"
                    isRequired={requiredFieldNames.includes('hedgeLf')}
                  />
                  <FastInput
                    name="hedgeLf"
                    type="number"
                    onWheel={e => e.target.blur()}
                    value={line?.hedgeItems?.hedgeLf || ''}
                    disabled={!isInEditMode}
                    className={requiredFieldErrors.includes('hedgeLf') ? 'form-control error' : 'form-control'}
                    onChange={value => this.handleUpdateLine('hedgeItems.hedgeLf', index, value)}
                    onBlur={e => e.target.value === '' && this.handleUpdateLine('hedgeItems.hedgeLf', index, null)}
                    backgroundColor="white"
                  />
                </CustomFormControl>
              </Flex>
            )}
          </VStack>
        )}
        {purchaseOrderId && (
          <>
            <Box paddingX="10px">
              <CL
                line={line}
                lineIndex={index}
                clResults={line.clResults}
                isInEditMode={isInEditMode}
                clType={line.opClType}
                opAverageThirdPartyClResult={line.opAverageThirdPartyClResult}
                handleCLChange={this.handleCLChange}
              />
            </Box>
            <Box paddingX="10px">
              <Temperatures
                line={line}
                lineIndex={index}
                temperatures={line.temperatures}
                isInEditMode={isInEditMode}
                opTempType={line.opTempType}
                handleTemperatureChanges={this.handleTemperatureChanges}
              />
            </Box>
          </>
        )}
      </VStack>
    );
  }
}

export default InternationalOrderLine;
